import { usePageContent } from "@appiodev/xcore-client/xcore-ui";
import { Box, Stack } from "@xcorejs/ui";
import FormControl from "design-system/xcore/Form/FormControl";
import Select, { OptionType } from "design-system/xcore/Select";
import { FC } from "react";
import { ValueType } from "react-select";
import { NewsPage } from "xcore/types";

import { Filter } from "./useFilters";
import { useRouter } from "next/router";

interface Props {
  products: Filter;
  category: Filter;
  year: Filter;

  onChange: (key: string) => (value: ValueType<OptionType>) => unknown;
}

const NewsFilter: FC<Props> = ({ products, category, year, onChange }) => {
  const { locale } = useRouter();
  const [content, { stringify }] = usePageContent<NewsPage>();

  return (
    <Stack direction={{ _: "column", sm: "row" }} gap={{ _: "1.5rem", sm: "3rem" }}>
      {[
        <Box width="100%" key={1}>
          <FormControl labelText={stringify(content.values.productPlaceholder)}>
            <Select
              {...products[0]}
              onChange={onChange("product")}
              placeholder={stringify(content.values.realProductPlaceholder)}
              isMulti
            />
          </FormControl>
        </Box>,
        <Box width="100%" key={2}>
          <FormControl labelText={stringify(content.values.categoryPlaceholder)}>
            <Select
              {...category[0]}
              onChange={onChange("category")}
              placeholder={stringify(content.values.realCategoryPlaceholder)}
              isMulti
            />
          </FormControl>
        </Box>,
        /* TODO: temporary change until its removal from Robe is requested */
        locale !== "fr" && (
          <Box width="100%">
            <FormControl labelText={stringify(content.values.yearPlaceholder)}>
              <Select
                {...year[0]}
                onChange={v => onChange("year")([v as any])}
                placeholder={stringify(content.values.realYearPlaceholder)}
                isClearable
              />
            </FormControl>
          </Box>
        )
      ].filter(Boolean)}
    </Stack>
  );
};

export default NewsFilter;
